export default __webpack_public_path__ + "static/spot-illo-morph-light-7711dac2d29f2a3112641d55bf1f23f184515610760d251ed9140132f353350c.mp4";